// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2WRHb","description":"PatientConsentPreview_description__1wIoJ"};